import { useMutation } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

const useCancelCompetitorsMutation = () => {
    return useMutation({
        mutationFn({ threadId }: { threadId: string }) {
            return salesApiService.aiAgent.email.cancelCompetitors({ threadId });
        },
    });
};

export default useCancelCompetitorsMutation;
